import { render, staticRenderFns } from "./ReminderPlanAdd.vue?vue&type=template&id=622bfefd&"
import script from "./ReminderPlanAdd.vue?vue&type=script&lang=js&"
export * from "./ReminderPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports